<i
    class="fa fa-map-marker map-icon"
    *ngIf="orderItem.productLocationMapImageUrl"
    (click)="openProductLocationMap()"
></i>

<lib-modal
    [title]="'users.product-location-map-title' | translate"
    [componentID]="'product-location-map' + orderItem.orderItemID"
    [bgColorClass]="ColorClass.Info"
    (onClose)="onClose()"
>
    <i class="fa fa-arrows zoom-icon" (click)="mapSizeChange()"></i>
    <div>
        <img
            [ngClass]="fullSizeMap ? 'full-size-map' : ''"
            [src]="orderItem.productLocationMapImageUrl"
            alt="Map"
        />
    </div>
</lib-modal>
